// extracted by mini-css-extract-plugin
module.exports = {"root":"MediumItem_root__eoHmx col-block","heading":"MediumItem_heading__232VS","date":"MediumItem_date__1sXVe","tags":"MediumItem_tags__13sA7"};